import Vue from 'vue'
import App from './App.vue'
import './plugins/jquery'
import './plugins/moment'
import './plugins/axios'
// import './plugins/sweetalert'
import './plugins/tippy'
import './plugins/print'
import './plugins/vue_scrollto'
import './plugins/ckeditor'
import './plugins/number-format'
import './plugins/otp'

import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';

import '@/assets/css/style-override.css'
import '@/assets/css/jquery.fancybox.min.css'

require('typeface-roboto')

import Roles from "./constants/roles";
Vue.use(Roles);

import BookingStatuses from "./constants/booking_statuses";
Vue.use(BookingStatuses);

import InvoiceStatuses from "./constants/invoice_statuses";
Vue.use(InvoiceStatuses);

import DeliveryStatuses from "./constants/delivery_statuses";
Vue.use(DeliveryStatuses);

import ShipmentTypes from "./constants/shipment_types";
Vue.use(ShipmentTypes);

import RewardStatuses from "./constants/reward_statuses";
Vue.use(RewardStatuses);

import RewardTypes from "./constants/reward_types";
Vue.use(RewardTypes);

Vue.config.productionTip = false

Vue.filter("formatNumber", function (value) {
  return new Intl.NumberFormat().format(value);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
